<section class="coming-soon-section">
  <img class="coming-soon-bg" src="assets/img/company/Section.png" alt="Background">
  
  <div class="coming-soon-center">
    <div class="content-wrapper">
      <div class="image-wrapper">
        <img src="assets/img/Group (3).png" alt="Coming Soon" class="coming-soon-img">
      </div>
      <h2 class="title-text">{{ 'dash.comingSoonTitle' | translate }}</h2>
      <h3 class="subtitle-text">{{ 'dash.stayTuned' | translate }}</h3>
      <button class="back-btn" routerLink="/company-admin/company-profile">
        {{ 'dash.backToDashboard' | translate }} <i class="bi bi-arrow-right"></i>
      </button>
    </div>
  </div>
</section>
